// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"a858be45","983":"b584abfe"}[chunkId] + ".chunk.js";
};